module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 12
// module chunks = 0